import React, { forwardRef } from "react";

import validator from "validator";
import Input from "../../1_elements/Input";

/* Props
*  label        : string
*  inputId      : string, to identify input and link it to its label
*  placeholder  : string
*  type         : string, can be integer / string to apply validation controls
*  isReadOnly   : bool, set to true if input shouldn't be modified
*/
const InputPassword = forwardRef( function InputPassword({
    ...props
}, ref) {
    /** 
     * Control errors based on the type of input
     */
    function controlErrors(value) {
        let error = false;
        let message = "";

        if (error = props.isRequired && (!value || value?.trim().length === 0)) {
            message = "Ce champ est obligatoire";
        } else if (error = value.trim().length > 0 && !validator.isStrongPassword(value)) {
            message = "Le mot de passe doit comporter au minimum 8 caractères dont au moins 1 chiffre, 1 minuscule, 1 majuscule, 1 caractère spécial";
        }
        
        return ({error: error, message: message});
    }

    const error = {controlErrors: controlErrors};

    return (
        <Input
            ref={ref}
            {...props}
            error={error}
            type="password"
        />
    )
})

export default InputPassword;